import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import api from 'api/api';
import SimpleTable from 'components/global/SimpleTable';
import Loader from 'components/global/Loader';
import DashboardTablePagination from './DashboardTablePagination';

const PAGE_SIZE = 25;

const HEADERS = [
  { key: 'businessName', title: 'Business' },
  { key: 'calcapLoanNumber', title: 'CalCAP Loan #' },
  { key: 'programName', title: 'Program' },
  { key: 'waitingRole', title: 'Waiting step' },
  { key: 'lenderLoanNumber', title: 'Lender Loan Number' },
];

const EdoDashboardApprovals = () => {
  const history = useHistory();
  const [loaded, setLoaded] = useState(false);
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      try {
        const res = await api.get({
          path: `/v2/edos/dashboard-pending-approval-chain?page=${page}&take=${PAGE_SIZE}`,
        });
        if (cancelled) return;
        setItems(Array.isArray(res?.items) ? res.items : []);
        setTotal(typeof res?.total === 'number' ? res.total : 0);
      } catch {
        if (cancelled) return;
        setItems([]);
        setTotal(0);
      } finally {
        if (!cancelled) setLoaded(true);
      }
    };
    load();
    return () => {
      cancelled = true;
    };
  }, [page]);

  const rows = items.map((row) => ({
    businessName: row.businessName || '-',
    calcapLoanNumber: row.calcapLoanNumber || '-',
    programName: row.programName || '-',
    waitingRole: row.waitingRole || '-',
    lenderLoanNumber: row.lenderLoanNumber || '-',
    id: row.id,
  }));

  const totalPages = Math.max(1, Math.ceil(total / PAGE_SIZE));

  return (
    <Container fluid className="py-24">
      <h4 className="text-primary font-weight-bold mb-8">
        Waiting for my approval ({loaded ? total : 0})
      </h4>
      <p className="text-muted small mb-16">
        Loans where you are the current person on the Approval Chain. Not Loan
        Tracking assignments.
      </p>
      {!loaded ? (
        <Loader className="py-24" message="Loading…" />
      ) : rows.length === 0 ? (
        <p className="text-muted mb-0">
          You have no applications waiting for your approval.
        </p>
      ) : (
        <>
          <div className="extend-table-container no-padding">
            <SimpleTable
              headers={HEADERS}
              rows={rows}
              tableProps={{ className: 'mb-0' }}
              onClick={(rowIndex) =>
                history.push(
                  `/edo/portfolio/${rows[rowIndex].id}?tab=approvalChain`
                )
              }
            />
          </div>
          <DashboardTablePagination
            currentPage={page}
            totalPages={totalPages}
            onPageChange={setPage}
          />
        </>
      )}
    </Container>
  );
};

export default EdoDashboardApprovals;
